const isStoryblokContentForWeb = (
  showOn?: "" | "App" | "Web" | "All",
  // show content without the showOn property for backwards compatibility
): boolean => !showOn || showOn === "Web" || showOn === "All";

export default isStoryblokContentForWeb;
